document.addEventListener('DOMContentLoaded', () => {
  const verticalMenu = document.getElementById('vertical-nav-css');
  const secondMenu   = document.querySelector('.mega-hover_2');
  const overlay      = document.getElementById('menu-overlay');

  const cursorSource = document.querySelector('.background-overlay > .background-cursor-wrapper');
  if (cursorSource && document.body.classList.contains('show_effect_close')) {
    const hoverPointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    document.querySelectorAll('#menu-overlay, #halo-store-hours-overlay').forEach(backdrop => {
      const cursor = cursorSource.cloneNode(true);
      cursor.classList.remove('enlarge-cursor');
      cursor.setAttribute('aria-hidden', 'true');
      cursor.style.pointerEvents = 'none';
      backdrop.append(cursor);

      const moveCursor = event => {
        if (!hoverPointer.matches || event.pointerType === 'touch' || document.body.classList.contains('safari')) return;
        cursor.style.setProperty('--translate-x', event.clientX);
        cursor.style.setProperty('--translate-y', event.clientY);
        cursor.classList.add('enlarge-cursor');
        backdrop.style.cursor = 'none';
      };
      const resetCursor = () => {
        cursor.classList.remove('enlarge-cursor');
        backdrop.style.removeProperty('cursor');
      };

      backdrop.addEventListener('pointerenter', moveCursor);
      backdrop.addEventListener('pointermove', moveCursor);
      backdrop.addEventListener('pointerleave', resetCursor);
      backdrop.addEventListener('click', resetCursor);
      hoverPointer.addEventListener('change', resetCursor);
    });
  }

  // Bail out if overlay is missing — or optionally check each menu’s existence before adding events.
  if (!overlay) return;

  // Helper functions
  function showOverlay() {
    overlay.classList.add('is-visible');
  }
  function hideOverlay() {
    overlay.classList.remove('is-visible');
  }

  // 1) Vertical menu events
  if (verticalMenu && verticalMenu.dataset.ibeadDesign !== 'true') {
    verticalMenu.addEventListener('mouseenter', showOverlay);
    verticalMenu.addEventListener('mouseleave', hideOverlay);
  }

  // 2) Second menu trigger with class .mega-hover_2
  if (secondMenu) {
    secondMenu.addEventListener('mouseenter', showOverlay);
    secondMenu.addEventListener('mouseleave', hideOverlay);
  }

  // (Optional) Hide overlay if user clicks anywhere on it
  overlay.addEventListener('click', hideOverlay);
});